import { useEffect, useRef } from "react";

import type { InputProps } from "semantic-ui-react";
import { Input as SemanticInput } from "semantic-ui-react";

export const Input = ({ ref, ...props }: InputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const input = inputRef.current;
    if (!input || props.type !== "number") return;

    const onWheel = (e: WheelEvent) => {
      e.preventDefault();
    };

    input.addEventListener("wheel", onWheel, { passive: false });
    return () => input.removeEventListener("wheel", onWheel);
  }, [props.type]);

  return (
    <SemanticInput
      {...props}
      input={{
        ref: (r: HTMLInputElement | null) => {
          inputRef.current = r;
          if (ref) {
            if (typeof ref === "function") {
              ref(r);
            } else {
              ref.current = r;
            }
          }
        },
      }}
    />
  );
};
